var path = '/app/pages/account-logout/account-logout.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account-logout/account-logout.html
// module id = 556
// module chunks = 0